"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../style");
var dropdownHeaderStyle = react_1.css({
    padding: '8px 12px',
    color: "var(" + style_1.TextColor.DEFAULT + ")",
    fontSize: 12,
    fontWeight: 500,
});
var DropdownGroupMenuHeader = function (_a) {
    var style = _a.style, className = _a.className, children = _a.children;
    return (react_1.jsx("div", { style: style, onClick: function (e) { return e.stopPropagation(); }, className: "sixsense-menu-group-header " + className, css: dropdownHeaderStyle }, children));
};
exports.default = DropdownGroupMenuHeader;
